const ASSET_ROOT = '/assets/food';

const CANONICAL = {
  farina: 'farina.webp', zucchero: 'zucchero.webp', latte: 'latte.webp', panna: 'panna.webp', burro: 'burro.webp',
  uovo: 'uova.webp', uova: 'uova.webp', cioccolato: 'cioccolato.webp', cacao: 'cacao.webp', lievito: 'lievito.webp',
  olio: 'olio.webp', mozzarella: 'mozzarella.webp', formaggio: 'formaggio.webp', carne: 'carne.webp', prosciutto: 'salumi.webp',
  salume: 'salumi.webp', salumi: 'salumi.webp', pomodoro: 'pomodoro.webp', insalata: 'insalata.webp', basilico: 'basilico.webp',
  verdura: 'verdure-miste.webp', verdure: 'verdure-miste.webp', 'frutta secca': 'frutta-secca.webp', frutta: 'frutta.webp', mandorla: 'frutta-secca.webp',
  nocciola: 'frutta-secca.webp', noce: 'frutta-secca.webp', miele: 'miele.webp', marmellata: 'marmellata.webp', pane: 'pane.webp',
  croissant: 'croissant.webp', cornetto: 'croissant.webp', biscotto: 'biscotti.webp', biscotti: 'biscotti.webp', torta: 'torta.webp',
  focaccia: 'focaccia.webp', forno: 'prodotto-forno.webp', crema: 'crema.webp', impasto: 'impasto.webp'
};

const normalize = (value) => String(value || '').toLocaleLowerCase('it').normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export function getProductImageSrc(item = {}) {
  if (item.image_key && item.ingredient_id) return `${process.env.REACT_APP_BACKEND_URL}/api/ingredients/${encodeURIComponent(item.ingredient_id)}/image?v=${encodeURIComponent(item.image_key)}`;
  const custom = item.image_url || item.photo_url || item.thumbnail_url || item.image || item.photo;
  if (custom) return custom;
  const haystack = normalize([
    item.commercial_name, item.ingredient_name, item.output_product_name, item.name, item.product_name
  ].filter(Boolean).join(' '));
  const key = Object.keys(CANONICAL).sort((a, b) => b.length - a.length).find((candidate) => haystack.includes(candidate));
  return key ? `${ASSET_ROOT}/${CANONICAL[key]}` : '';
}

export function productInitials(item = {}) {
  const value = item.commercial_name || item.ingredient_name || item.output_product_name || item.name || item.product_name || '';
  const words = String(value).trim().split(/\s+/).filter(Boolean);
  return (words.slice(0, 2).map((word) => word[0]).join('') || '—').toUpperCase();
}
